import "./bootstrap/bootstrap";

// shido plugins
import dimentions from "../../../node_modules/shido.dimentions.js/src/dimentions.js";
import forms from "../../../node_modules/shido.forms.js/src/forms.js";
import regular from "../../../node_modules/shido.regular.js/src/regular.js";

// app
// require('../../../node_modules/...')
import alert from "./components/alerts";
import MainNav from "./components/main-nav";
import DeferImages from "./components/defer-images";
import collapse from "./components/collapse";
import { SendAjaxOnClick } from "./components/send-ajax";
import selectsRefactor from "./components/selectsRefactor";
import searchForm from "./components/search-form";
import autocomplete from "./components/autocomplete";
import anchor from "./components/anchor";
import { Banners } from "./components/glide";

// require('paroller.js')
require("@fancyapps/fancybox");
import LazyLoad from "vanilla-lazyload";

// Initializers
const docReady = () => {
  new dimentions().init();
  new alert().session();
  new forms().init();
  new regular().init();

  new collapse().init();

  MainNav();
  DeferImages();
  SendAjaxOnClick();
  selectsRefactor();
  searchForm();
  Banners();

  new autocomplete().init();
  new anchor().init();

  var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
  });
};

const winLoad = () => {
  // ...
};

const docReadyWinload = () => {
  // ...
};

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener(
  "DOMContentLoaded",
  () => {
    docReady();
    docReadyWinload();
  },
  false
);
window.addEventListener(
  "load",
  () => {
    winLoad();
    docReadyWinload();
  },
  false
);
// ---
// ---
